export const assorted = {
    default: "#62ADE0",
    subtle: "#78BEE9",
    strong: "#1E89D2",
};
